import { render, staticRenderFns } from "./unreceived.vue?vue&type=template&id=597e6cc6&scoped=true"
import script from "./unreceived.vue?vue&type=script&lang=js"
export * from "./unreceived.vue?vue&type=script&lang=js"
import style0 from "./unreceived.vue?vue&type=style&index=0&id=597e6cc6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597e6cc6",
  null
  
)

export default component.exports